import React from 'react';
import { useSelector } from 'react-redux';
import { buttons, icons, textblocks } from 'seal-ui-components';
import { dismissError } from '@Actions/notificationHandlingActions';
import { NOTIFICATION_TYPE } from '@Reducers/notificationHandlingReducer';
import { HorizontalBox, ErrorWrapper, WarningWrapper } from './NotificationMessage.style';

const { Heading4, Text } = textblocks;

const NotificationMessage = () => {
    const { errorMessageInfo: messageText, hasNotification, notificationType } = useSelector(
        state => state.notificationHandling
    );

    const renderNotification = (message, header) => {
        return (
            <HorizontalBox>
                <div>
                    <buttons.IconButton
                        icon={<icons.CrossMediumIcon />}
                        aria-label="Close"
                        onClick={() => dismissError()}
                    />
                    {header && <Heading4>{header}</Heading4>}
                    <Text>{message}</Text>
                </div>
            </HorizontalBox>
        );
    };

    return (
        hasNotification && (
            <>
                {notificationType === NOTIFICATION_TYPE.ERROR && (
                    <ErrorWrapper data-testid="error_notification">
                        {renderNotification(
                            'Please try again or if the issue persists Please copy log information to the clipboard, then paste this into an email and send it to your support desk.',
                            'Something went wrong'
                        )}
                    </ErrorWrapper>
                )}
                {notificationType === NOTIFICATION_TYPE.DISPLAY_ERROR && (
                    <ErrorWrapper data-testid="display_error_notification">
                        {renderNotification(messageText)}
                    </ErrorWrapper>
                )}
                {(notificationType === NOTIFICATION_TYPE.WARNING ||
                    notificationType === NOTIFICATION_TYPE.INFO) && (
                    <WarningWrapper data-testid="warning_notification">
                        {renderNotification(messageText)}
                    </WarningWrapper>
                )}
            </>
        )
    );
};

export default NotificationMessage;
